import React, { Fragment, useEffect, useState } from "react"

import { PrevCard, CardDiv, CurrentCard } from "./GambleComponentsStyled"
import { CARD_PROPS } from "./interface"
import { useCard } from "@orbital/games-frontend-library"
import usePreviousCard from "./helperFunctions/usePreviousCard"

export default function GambleCard({
  card,
  colors,
  changeCard,
  gambleHistory,
}: CARD_PROPS) {
  const { handleCardSymbol, handleCardColor, handleCardSuit } = useCard()

  const [gambleCard, setGambleCard] = useState<string>(card)
  const prevCard = usePreviousCard(gambleCard)

  useEffect(() => {
    setGambleCard(card)
  }, [card])

  return (
    <Fragment>
      <CardDiv changeCard={changeCard}>
        <CurrentCard
          changeCard={changeCard}
          color={
            card &&
            handleCardColor(
              card === "X0" ? gambleHistory[0] : card,
              colors && colors.secondaryText,
              colors && colors.secondaryBackground,
            )
          }
        >
          <p>
            {card && handleCardSymbol(card === "X0" ? gambleHistory[0] : card)}
          </p>
          {card && handleCardSuit(card === "X0" ? gambleHistory[0] : card)}
        </CurrentCard>
        {changeCard && card !== "X0" && typeof prevCard !== "undefined" && (
          <PrevCard
            changeCard={changeCard && card !== "X0"}
            color={
              gambleHistory[1] &&
              handleCardColor(
                gambleHistory[1],
                colors && colors.secondaryText,
                colors && colors.secondaryBackground,
              )
            }
          >
            <p>{gambleHistory[1] && handleCardSymbol(gambleHistory[1])}</p>
            {gambleHistory[1] && handleCardSuit(gambleHistory[1])}
          </PrevCard>
        )}
      </CardDiv>
    </Fragment>
  )
}
